export default "__VITE_ASSET__C$zv7dYr__"